import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import enTranslations from './locales/en.json';
import arTranslations from './locales/ar.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enTranslations
      },
      ar: {
        translation: arTranslations
      }
    },
    lng: 'en', // 👈 Force default language to English on first load
    fallbackLng: 'en', // 👈 Use English if detection fails
    debug: true,
    interpolation: {
      escapeValue: false
    }
  });

export default i18n; 